import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { CashPaymentClient } from "../../../../../../../../Wrap/Api/PortfolioAnalysis/Payment/CashPayment";
import { AccountTransfersClient } from "../../../../../../../../Wrap/Api/Transaction/AccountTransfers";
import { AutoDisInvestTranWithBatchIdClient } from "../../../../../../../../Wrap/Api/Transaction/AutoDisInvestTranWithBatchId";
import { CashEntryDetailClient } from "../../../../../../../../Wrap/Api/Transaction/CashEntryDetail";
import { CashLedgerTransactionWithBatchIdClient } from "../../../../../../../../Wrap/Api/Transaction/CashLedgerTransactionWithBatchId";
import { CashTransactionClient } from "../../../../../../../../Wrap/Api/Transaction/CashTransaction";
import { CgtTransactionClient } from "../../../../../../../../Wrap/Api/Transaction/CgtTransaction";
import { CgtTransactionHistoryClient } from "../../../../../../../../Wrap/Api/Transaction/CgtTransactionHistory";
import { ChargesTransactionsClient } from "../../../../../../../../Wrap/Api/Transaction/ChargesTransactions";
import { DisinvestEventChargeClient } from "../../../../../../../../Wrap/Api/Transaction/DisinvestEventCharge";
import { DividendSummaryClient } from "../../../../../../../../Wrap/Api/Transaction/DividendSummary";
import { InvestmentTransactionClient } from "../../../../../../../../Wrap/Api/Transaction/InvestmentTransaction";
import { InvestmentTransactionByTransIdClient } from "../../../../../../../../Wrap/Api/Transaction/InvestmentTransactionByTransId";
import { OffPlatformIncomesClient } from "../../../../../../../../Wrap/Api/Transaction/OffPlatformIncomes";
import { OrderHistoryClient } from "../../../../../../../../Wrap/Api/Transaction/OrderHistory";
import { OrderValuationClient } from "../../../../../../../../Wrap/Api/Transaction/OrderValuation";
import { OtherCorporateActionsClient } from "../../../../../../../../Wrap/Api/Transaction/OtherCorporateActions";
import { TransactionsSummaryClient } from "../../../../../../../../Wrap/Api/Transaction/TransactionsSummary";
import { ServiceValidationError } from "../../../../../../../../Wrap/Core/DataTypes/ServiceValidation/ServiceValidationError";
import { SortDirection } from "../../../../../../../../Wrap/Core/SortingAndPaging/SortDirection";
import { AccountTransfersSort } from "../../../../../../../../Wrap/Models/Domains/Transactions/AccountTransfers/AccountTransfersSort";
import { CashEntryDetail } from "../../../../../../../../Wrap/Models/Domains/Transactions/Cash/CashEntryDetail";
import { CashLedgerTransaction } from "../../../../../../../../Wrap/Models/Domains/Transactions/Cash/CashLedgerTransaction";
import { CashTransactionTypes } from "../../../../../../../../Wrap/Models/Domains/Transactions/Cash/CashTransactionTypes";
import { ChargesQuerySort } from "../../../../../../../../Wrap/Models/Domains/Transactions/Charges/ChargesQuerySort";
import { ChargesQueryType } from "../../../../../../../../Wrap/Models/Domains/Transactions/Charges/ChargesQueryType";
import { BouncedCharge } from "../../../../../../../../Wrap/Models/Domains/Transactions/Investments/BouncedCharge";
import { CgtTransaction } from "../../../../../../../../Wrap/Models/Domains/Transactions/Investments/CgtTransaction";
import { CgtTransactionHistory } from "../../../../../../../../Wrap/Models/Domains/Transactions/Investments/CgtTransactionHistory";
import { InvestmentTransactions } from "../../../../../../../../Wrap/Models/Domains/Transactions/Investments/InvestmentTransactions";
import { OrderHistory } from "../../../../../../../../Wrap/Models/Domains/Transactions/Investments/OrderHistory";
import { OrderValuation } from "../../../../../../../../Wrap/Models/Domains/Transactions/Investments/OrderValuation";
import { CashPaymentFrequencyQuery } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentFrequencyQuery";
import { CashPaymentTypeQuery } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentTypeQuery";
import { TransactionEnum } from "../Resource/Contents";
import { TransactionDispatcher, TransactionStore } from "../Store/Variable";

export class TransactionAction {
    public static getAccountTransfer(
        hierarchyId: string,
        fromDate: Date,
        toDate: Date,
        fromInception: boolean,
        minrow: number,
        maxrow: number,
        sortby: AccountTransfersSort,
        sortByAscending: boolean
    ): void {
        const client = new AccountTransfersClient();
        const promise = client.get(
            hierarchyId,
            JsonDateParser.toJsonDateNoOffset(fromDate),
            JsonDateParser.toJsonDateNoOffset(toDate),
            fromInception,
            minrow,
            maxrow,
            sortby,
            sortByAscending
        );

        this.updateTransactionStore(TransactionEnum.accountTransfers, promise);
    }

    public static getPaymentWithdrawals(
        hierarchyId: string,
        fromDate: Date,
        toDate: Date,
        fromInception: boolean,
        type: CashPaymentTypeQuery,
        frequency: CashPaymentFrequencyQuery
    ) {
        const client = new CashPaymentClient();
        const promise = client.get(hierarchyId, type, frequency);

        this.updateTransactionStore(TransactionEnum.paymentsWithdrawals, promise);
    }

    public static getDividendSummary(
        hierarchyId: string,
        fromDate: Date,
        toDate: Date,
        fromInception: boolean,
        instrumentCode: string,
        corpActionType: string,
        sortName: string,
        sortDirection: string,
        minRow: number,
        maxRow: number
    ): void {
        const client = new DividendSummaryClient();
        const promise = client.get(
            hierarchyId,
            JsonDateParser.toJsonDateNoOffset(fromDate),
            JsonDateParser.toJsonDateNoOffset(toDate),
            fromInception,
            instrumentCode,
            corpActionType,
            sortName,
            sortDirection,
            minRow,
            maxRow
        );

        if (corpActionType) {
            this.updateTransactionStore(TransactionEnum.corporateActions, promise);
        } else {
            this.updateTransactionStore(TransactionEnum.otherCorporateActions, promise);
        }
    }

    public static getOtherCorporateActions(
        hierarchyId: string,
        fromDate: Date,
        toDate: Date,
        fromInception: boolean,
        instrumentCode: string,
        corpActionType: string,
        sortName: string,
        sortDirection: string,
        minRow: number,
        maxRow: number
    ): void {
        const client = new OtherCorporateActionsClient();
        const promise = client.get(
            hierarchyId,
            JsonDateParser.toJsonDateNoOffset(fromDate),
            JsonDateParser.toJsonDateNoOffset(toDate),
            fromInception,
            instrumentCode,
            corpActionType,
            sortName,
            sortDirection,
            minRow,
            maxRow
        );

        if (corpActionType) {
            this.updateTransactionStore(TransactionEnum.corporateActions, promise);
        } else {
            this.updateTransactionStore(TransactionEnum.otherCorporateActions, promise);
        }
    }
    public static getCharges(
        hierarchyId: string,
        fromDate: Date,
        toDate: Date,
        fromInception: boolean,
        chargesType: ChargesQueryType,
        sortby: ChargesQuerySort,
        sortByAscending: boolean
    ): void {
        const client = new ChargesTransactionsClient();
        const promise = client.get(
            hierarchyId,
            JsonDateParser.toJsonDateNoOffset(fromDate),
            JsonDateParser.toJsonDateNoOffset(toDate),
            fromInception,
            chargesType,
            sortby,
            sortByAscending
        );

        this.updateTransactionStore(TransactionEnum.charges, promise);
    }

    public static getOffPlatformIncome(
        hierarchyId: string,
        fromDate: Date,
        toDate: Date,
        fromInception: boolean,
        minrow: number,
        maxrow: number
    ): void {
        const client = new OffPlatformIncomesClient();
        const promise = client.get(
            hierarchyId,
            JsonDateParser.toJsonDateNoOffset(fromDate),
            JsonDateParser.toJsonDateNoOffset(toDate),
            fromInception,
            minrow,
            maxrow
        );

        this.updateTransactionStore(TransactionEnum.offPlatformIncome, promise);
    }

    public static getInvestmentTransactions(
        hierarchyId: string,
        fromDate: Date,
        toDate: Date,
        cNoteId: number,
        instrumentCode: string,
        transSource: string,
        sortName: string,
        sortDirection: string,
        modelId: number,
        minRow: number,
        maxRow: number
    ): void {
        const client = new InvestmentTransactionClient();
        const promise = client.get(
            hierarchyId,
            modelId,
            JsonDateParser.toJsonDateNoOffset(fromDate),
            JsonDateParser.toJsonDateNoOffset(toDate),
            transSource,
            instrumentCode,
            cNoteId,
            sortName,
            sortDirection,
            minRow,
            maxRow
        );

        this.updateTransactionStore(TransactionEnum.investments, promise);
    }

    public static getCashTransactions(
        hierarchyId: string,
        fromDate: Date,
        toDate: Date,
        fromInception: boolean,
        movementType: CashTransactionTypes,
        modelId: number,
        sortDirection: SortDirection,
        minRow: number,
        maxRow: number
    ): void {
        const client = new CashTransactionClient();
        const promise = client.get(
            hierarchyId,
            JsonDateParser.toJsonDateNoOffset(fromDate),
            JsonDateParser.toJsonDateNoOffset(toDate),
            fromInception,
            movementType,
            modelId,
            minRow,
            maxRow,
            sortDirection
        );

        this.updateTransactionStore(TransactionEnum.cash, promise);
    }

    public static getSummaryTransactions(
        hierarchyId: string,
        fromDate: Date,
        toDate: Date,
        fromInception: boolean
    ): void {
        const client = new TransactionsSummaryClient();
        const promise = client.get(
            hierarchyId,
            JsonDateParser.toJsonDateNoOffset(fromDate),
            JsonDateParser.toJsonDateNoOffset(toDate),
            fromInception
        );

        this.updateTransactionStore(TransactionEnum.summary, promise);
    }

    private static updateTransactionStore(transType: TransactionEnum, promise: any) {
        promise.onSuccess((result) => {
            let data = JSON.parse(JSON.stringify(TransactionStore.getData()));
            if (!data) {data = {};}
            data[transType] = result;
            TransactionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });

        promise.onError((err) => {
            TransactionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getTransactionsByTransId(transId: number, callback?: (val: InvestmentTransactions) => void): void {
        const client = new InvestmentTransactionByTransIdClient();
        const promise = client.get(transId);
        promise.onSuccess((res) => {
            if (callback) {
                callback(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getCgtTransactionByTransId(transId: number, callback?: (val: CgtTransaction) => void): void {
        const client = new CgtTransactionClient();
        const promise = client.get(transId);
        promise.onSuccess((res) => {
            if (callback) {
                callback(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getCgtTransactionsHistoryByTransId(
        transId: number,
        callback?: (val: Array<CgtTransactionHistory>) => void
    ): void {
        const client = new CgtTransactionHistoryClient();
        const promise = client.get(transId);
        promise.onSuccess((res) => {
            if (callback) {
                callback(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static saveCgtTransactions(
        cgtTransaction: CgtTransaction,
        callback?: (val: ServiceValidationError[]) => void
    ): void {
        const client = new CgtTransactionClient();
        const promise = client.post(cgtTransaction);
        promise.onSuccess((res: ServiceValidationError[]) => {
            if (callback) {
                callback(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getClientTransactionOrder(orderId: number, callback?: (val: Array<OrderValuation>) => void): void {
        const client = new OrderValuationClient();
        const promise = client.get(orderId);
        promise.onSuccess((res) => {
            if (callback) {
                callback(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getTransactionOrderHistory(orderId: number, callback?: (val: Array<OrderHistory>) => void): void {
        const client = new OrderHistoryClient();
        const promise = client.get(orderId);
        promise.onSuccess((res) => {
            if (callback) {
                callback(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getDisinvestCharge(orderId: number, callback?: (val: Array<BouncedCharge>) => void): void {
        const client = new DisinvestEventChargeClient();
        const promise = client.get(orderId);
        promise.onSuccess((res) => {
            if (callback) {
                callback(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getCashEntryDetail(cashId: number, callback?: (val: Array<CashEntryDetail>) => void): void {
        const client = new CashEntryDetailClient();
        const promise = client.get(cashId);
        promise.onSuccess((res) => {
            if (callback) {
                callback(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getCashLedgerTransactionWithBatchId(
        transId: number,
        callback?: (val: Array<CashLedgerTransaction>) => void
    ): void {
        const client = new CashLedgerTransactionWithBatchIdClient();
        const promise = client.get(transId);
        promise.onSuccess((res) => {
            if (callback) {
                callback(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getAutoDisInvestTranWithBatchId(
        transId: number,
        callback?: (val: Array<CashLedgerTransaction>) => void
    ): void {
        const client = new AutoDisInvestTranWithBatchIdClient();
        const promise = client.get(transId);
        promise.onSuccess((res) => {
            if (callback) {
                callback(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }
}
